export default __webpack_public_path__ + "static/media/christmas_border_bottom.936994aa.png";